export default __webpack_public_path__ + "static/media/hotpatch-logo.50fccfd7.png";